import script from "./TmDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TmDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./TmDetailComponent.vue?vue&type=style&index=0&id=e2c88e5e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2c88e5e"]])

export default __exports__